<template>
	<div>
		<CRow>
			<CCol sm="12">
				<CButton @click="collapse=!collapse" color="primary" class="mb-2 ml">
					فیلتر داده‌ها
				</CButton>
				<CButton @click="redirect_to(`/blacklist/custom/add`)"
					v-show="$store.state.perms.can_add_black_lists" color="primary" class="mb-2">
					افزودن شماره</CButton>
				<CCollapse :show="collapse" :duration="400">
					<CCard>
						<CCardHeader>
							<strong>گزینه‌های فیلتر</strong>
						</CCardHeader>
						<CCardBody>
							<CRow>
								<CCol sm="3">
                                    <label>کاربر</label>
                                    <model-select :options="users" v-model="form.user_id.val" placeholder="انتخاب کنید">
                                    </model-select>
                                    <small class="form-text text-muted w-100">{{form.user_id.inv}}</small>
                                </CCol>
								<CCol sm="3">
                                    <CInput v-model="form.from_number.val" size="sm" dir="ltr" disabled />
                                    <CButton @click="modal=true" size="sm" color="info" block>انتخاب شماره</CButton>
                                </CCol>
								<CCol sm="3">
									<CInput v-model="form.to_number.val" :description="form.to_number.inv" dir="ltr" label="به شماره" />
								</CCol>
							</CRow>
							<br>
							<div class="form-group form-actions">
								<CButton @click="validator();filter=true;page=1;get()" class="ml" color="primary">فیلتر</CButton>
								<CButton @click="remove_filter" color="danger">حذف فیلتر</CButton>
							</div>
						</CCardBody>
					</CCard>
				</CCollapse>
			</CCol>
			<CCol col="12" xl="12">
				<CCard>
					<CCardHeader>
						<strong>لیست سیاه اختصاصی</strong> 
						<div class="card-header-actions">
							تعداد: {{row_count}}
						</div>
					</CCardHeader>
					<CCardBody>
						<CCol sm="5">
							<CSelect v-model="limit" horizontal label="تعداد سطرها" :options="[
							{value: 10}, {value: 20}, {value: 50}, {value: 100}]" class="row-count"
							placeholder="تعداد سطرها" @change="limit=$event.target.value" />
						</CCol>
						<CDataTable hover striped :items="items" :fields="fields" :noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }">
							<template #full_deny="data">
								<td v-if="data.item.full_deny">
									<CIcon name="cilCheckAlt" size="lg"/>
								</td>
								<td v-else>
									<CIcon name="cilX" size="lg"/>
								</td>
							</template>
							<template #action="data">
								<td>
									<template>
										<div class="flex-container">
											<div v-show="$store.state.perms.can_update_custom_black_lists"
												@click="redirect_to(`/blacklist/custom/${data.item.id}/edit`)"
												v-c-tooltip.hover="'ویرایش'">
												<CIcon name="cilPencil" size="lg"/>
											</div>
											<div @click="delete_modal=true;id=data.item.id"
												v-c-tooltip.hover="'حذف'"
												v-show="$store.state.perms.can_delete_custom_black_lists">
												<CIcon name="cilTrash" size="lg"/>
											</div>
										</div>
									</template>
								</td>
							</template>
					</CDataTable>
					<br>
					<div> 
						<CPagination
						:activePage.sync="page"
						:pages="page_count"
						align="center"
						:doubleArrows="true"
						/>
					</div>
				</CCardBody>
			</CCard>
			</CCol>
			<CModal
				title="دقت کنید"
				size="sm"
				color="danger"
				:show.sync="delete_modal"
				>
				<p>آیا برای حذف شناسه {{id}} اطمینان دارید؟</p>
				<template #footer>
					<CButton @click="delete_modal=false" color="secondary">خیر</CButton>
					<CButton @click="delete_row" color="danger">بله</CButton>
				</template>
			</CModal>
			<CModal
            title="انتخاب شماره"
            size="sm"
            color="info"
            :show.sync="modal"
            >
            <CRow>
                <CCol sm="12">
                    <CInput v-model="number_like" @keyup.enter="access=false;get_numbers()" dir="ltr" label="جستجو در شماره‌ها"/>
                    <small>راهنما: برای جستجو در شماره‌ها چند رقم از شماره مورد نظر را وارد کرده و سپس دکمه Enter را فشار دهید. پس از نمایش پیغام پایان جستجو، شماره مورد نظر را از زیر انتخاب کنید.</small>
                </CCol>
                <CCol sm="12">
                    <br/>
                    <label>انتخاب شماره</label>
                    <model-select :options="numbers" v-model="from_selected" placeholder="انتخاب کنید">
                    </model-select>
                    <small class="form-text text-muted w-100">{{form.from_number.inv}}</small>
                </CCol>
            </CRow>
            <template #footer>
                <CButton @click="form.from_number.val=from_selected;modal=false;" color="primary">تایید</CButton>
                <CButton @click="modal=false" color="secondary">بستن</CButton>
            </template>
        </CModal>
		</CRow>
	</div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import validator from '../mixins'
export default {
    mixins: { validator },
	components: { ModelSelect },
	data() {
		return {
			row_count: '',
			items: [],
			fields: [
                { key: 'user_name', label: 'کاربر' },
                { key: 'from_number', label: 'از شماره' },
                { key: 'to_number', label: 'به شماره' },
                { key: 'full_deny', label: 'وضعیت' },
                { key: 'action', label: 'عملیات' },
			],
			collapse: false,
			form: {
				user_id: {val: '', inv: '', v: {max: 8}},
				from_number: {val: '', inv: '', v: {max: 64}},
				to_number: {val: '', inv: '', v: {max: 16}},
			},
			disable: false,
			page: 1,
			page_count: 0,
			offset: 0,
			limit: 10,
			delete_modal: false,
			id: 0,
			users: [],
			numbers: [],

			number_like: '',
            access: true,
            modal: false,
            from_selected: '',
		}
	},
	watch: {
		page: {
			handler() {
                this.get();
                window.scrollTo({ top: 0, behavior: 'smooth' });
			}
		},
		limit: {
			handler() {
				this.disable = false;
				this.get();
			}
		},
	},
	mounted() {
		this.get();
		this.get_users();
	},
	methods: {
		get() {
			if(this.disable == false){
				let filter = '';
				for (const key in this.form) {
					if(this.form[key].val != ''){
						filter += `&${key}=` + this.form[key].val;
					}
				}
				this.axios.get('custom_black_lists/'
					+ '?count=1'
					+ filter)
					.then(res => {
						this.row_count = String(res.data.count).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        if(res.data.count > this.limit){
                            this.page_count = Math.ceil(res.data.count / this.limit);
                        } else {
                            this.page_count = 1;
                        }
						this.offset = 0;
						if(this.page != 1){
							this.offset = (this.page * this.limit) - this.limit;
						}
					})
				.finally(() => {
					this.axios.get('custom_black_lists/'
						+ '?limit=' + this.limit
						+ '&offset=' + this.offset
						+ '&user_info=1'
						+ filter)
						.then(res => {
							res.data.map(val => {
								val.user_name = `${val.user_info.first_name} ${val.user_info.last_name}`;
							});
							this.items = res.data;
						})
				})
			}
		},
		delete_row() {
			this.axios.delete('custom_black_lists/'
			+ this.id)
			.then(() => {
				this.$notify({
					group: 'foo',
					type: 'success',
					text: 'حذف با موفقیت انجام شد.'
				});
				this.delete_modal = false;
                this.count();
				this.get();
			})
			.catch(() => {
				this.$notify({
					group: 'foo',
					type: 'error',
					text: 'خطا! لطفا مجددا تلاش کنید.'
				});
				this.delete_modal = false;
			})
		},
		remove_filter() {
            for (const key in this.form) {
                this.form[key].val = '';
                this.form[key].inv = '';
            }
            this.disable = false;
            this.filter = false;
            this.page = 1;
            this.count();
            this.get();
		},
		get_users(){
            this.axios.get('users/?type=view_user_nums')
                .then(res => {
                    res.data.map(val => {
                        this.users.push({value: val.id, text: `${val.id} - ${val.name}`})
                    });
                })
		},
		get_numbers() {
            this.axios.get('user_nums/' 
                + '?user_id=' + this.form.user_id.val
                + '&number_like=' + this.number_like)
                .then(res => {
                    res.data.map(val => {
                        this.numbers.push({ value: `${val.number}`, text: `${val.number}`});
                    });
                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        text: 'جستجوی شماره‌ها با موفقیت انجام شد.'
                    });
                })
        },
		redirect_to(route) {
			this.$router.push(route);
        },
	},
	beforeCreate(){
		if(this.$store.state.perms.can_view_custom_black_lists_page == false
			&& this.$store.state.verif == false){
			this.$router.push('/403')
		}
	},
}
</script>